/**
 * List of KEYS to be used in the storage.
 */
const Keys = {
    TOKEN: 'token-jwt',
};

/**
 * Static class to be used to store data in the browser localStorage.
 */
class Storage {

    /**
     * Set a value in the key.
     * @param {String} key 
     * @param {Object} value 
     */
    static set(key, value) {
        return localStorage.setItem(key, JSON.stringify(value));
    }

    /**
     * Get 
     * @param {String} key 
     */
    static get(key) {
        return JSON.parse(localStorage.getItem(key));
    }
    
    /**
     * 
     * @param {String} key 
     */
    static del(key) {
        localStorage.removeItem(key);
    }
}

export { Storage, Keys };
